import type {
  TypographyOptions,
  TypographyStyle,
  Variant,
} from '@mui/material/styles/createTypography';
import ceil from 'lodash/ceil';

const fontFamily = 'inherit';

function generateFontStyle(weight: number, fontSize: number, lineHeight: number) {
  return {
    fontFamily,
    fontWeight: weight,
    fontSize: `${fontSize / 16}rem`,
    lineHeight: ceil(lineHeight / fontSize, 3),
  };
}

export const typographyCustomOption = {
  CaptionSmallRegular: generateFontStyle(400, 10, 16),
  CaptionSmallMedium: generateFontStyle(500, 10, 16),
  CaptionSmallStrong: generateFontStyle(700, 10, 16),
  CaptionSmallHeavy: generateFontStyle(950, 10, 16),
  CaptionRegular: generateFontStyle(400, 12, 20),
  CaptionMedium: generateFontStyle(500, 12, 20),
  CaptionStrong: generateFontStyle(700, 12, 20),
  CaptionHeavy: generateFontStyle(950, 12, 20),
  BodyLight: generateFontStyle(200, 14, 24),
  BodyRegular: generateFontStyle(400, 14, 24),
  BodyMedium: generateFontStyle(500, 14, 24),
  BodyMedium_1: generateFontStyle(500, 14, 24),
  BodyStrong: generateFontStyle(700, 14, 24),
  BodyHeavy: generateFontStyle(950, 14, 24),
  BodyLargeLight: generateFontStyle(200, 16, 28),
  BodyLargeRegular: generateFontStyle(400, 16, 28),
  BodyLargeMedium: generateFontStyle(500, 16, 28),
  BodyLargeMedium_1: generateFontStyle(500, 16, 28),
  BodyLargeStrong: generateFontStyle(700, 16, 28),
  BodyLargeHeavy: generateFontStyle(950, 16, 28),
  HeadlineLight: generateFontStyle(200, 20, 36),
  HeadlineRegular: generateFontStyle(400, 20, 36),
  HeadlineMedium: generateFontStyle(500, 20, 36),
  HeadlineStrong: generateFontStyle(700, 20, 36),
  HeadlineHeavy: generateFontStyle(950, 20, 36),
  TitleLight: generateFontStyle(200, 24, 40),
  TitleRegular: generateFontStyle(400, 24, 40),
  TitleMedium: generateFontStyle(500, 24, 40),
  TitleStrong: generateFontStyle(700, 24, 40),
  TitleHeavy: generateFontStyle(950, 24, 40),
  DisplayLight: generateFontStyle(200, 32, 48),
  DisplayRegular: generateFontStyle(400, 32, 48),
  DisplayMedium: generateFontStyle(500, 32, 48),
  DisplayStrong: generateFontStyle(700, 32, 48),
  DisplayHeavy: generateFontStyle(950, 32, 48),
};

export type TypographyCustomVariants = keyof typeof typographyCustomOption;

declare module '@mui/material/styles' {
  export interface TypographyVariants extends Record<TypographyCustomVariants, TypographyStyle> {}

  export interface TypographyVariantsOptions
    extends Record<TypographyCustomVariants, TypographyStyle> {}
}

declare module '@mui/material/Typography' {
  
  interface TypographyPropsVariantOverrides
    extends Record<Variant, false>,
      Record<TypographyCustomVariants, true> {}
}

const typographyOption: TypographyOptions = {
  fontFamily,
  ...typographyCustomOption,
  h1: typographyCustomOption.DisplayHeavy,
  h2: typographyCustomOption.DisplayStrong,
  h3: typographyCustomOption.DisplayMedium,
  h4: typographyCustomOption.TitleStrong,
  h5: typographyCustomOption.HeadlineStrong,
  h6: typographyCustomOption.BodyLargeStrong,
  subtitle1: typographyCustomOption.BodyLargeMedium,
  subtitle2: typographyCustomOption.BodyMedium,
  body1: typographyCustomOption.BodyLargeRegular,
  body2: typographyCustomOption.BodyRegular,
  button: typographyCustomOption.BodyLargeMedium_1,
  caption: typographyCustomOption.CaptionRegular,
  overline: typographyCustomOption.CaptionSmallRegular,
};

export const typography = typographyOption;







